import React, { useState } from 'react';
import CustomSelect from '../customSelect/customSelect';
import apiService from '../../../services/apiService';
import CustomToast from '../../Toast';
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from 'react-modal';


const Details = ({ userInfo }) => {

    const [selectedGender, setSelectedGender] = useState('');
    const [selectedAgeGroup, setSelectedAgeGroup] = useState('');
    const [isModalOpen, setModalOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const ageGroupOptions = [
        { value: 'Boomers: 1946 - 1964', label: 'Boomers: 1946 - 1964' },
        { value: 'Gen X: 1965 - 1980', label: 'Gen X: 1965 - 1980' },
        { value: 'Millenials: 1981 - 1996', label: 'Millenials: 1981 - 1996' },
        { value: 'Gen Z: 1997 - 2012', label: 'Gen Z: 1997 - 2012' },
        { value: 'Alpha: 2013 - 2025', label: 'Alpha: 2013 - 2025' },
        { value: 'Prefer not to state', label: 'Prefer not to state' },
    ];

    const genderOptions = [
        { value: 'Woman', label: 'Woman' },
        { value: 'Man', label: 'Man' },
        { value: 'Others', label: 'Others' },
        { value: 'Prefer not to state', label: 'Prefer not to state' },
    ];

    const handleAgeGroupChange = (value) => {
        setSelectedAgeGroup(value);
    };

    const handleGenderChange = (value) => {
        setSelectedGender(value);
    };
    const openVideoModal = () => {
        setModalOpen(true);
    };

    const closeVideoModal = () => {
        setModalOpen(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let formData = {
            gender: selectedGender || 'Prefer not to state',
            age_group: selectedAgeGroup || 'Prefer not to state',
            email: userInfo?.email,
            uid: userInfo?.uid
        }
        try {
            const token = apiService.getAuthToken();
            const response = await apiService.putWithoutFormData('update-org-manage-user-info', formData, token);

            if (response && response.status === 'success') {
                const result = await apiService.get('get-org-user-info', token);
                if (result && result.status == "success") {
                    localStorage.setItem('user_details', JSON.stringify(result?.data))
                }
                CustomToast.success('Profile updated successfully')
                setTimeout(() => {
                    window.location.reload(true);
                }, 1000);
            } else {
                CustomToast.error('Failed to update profile');
            }
        } catch (error) {
            // console.log("sdasa", error)
            CustomToast.error('Failed to update profile');
            if (error == "Invalid token id!") {
                localStorage.removeItem('authToken');
                localStorage.removeItem('user_details');
                window.location.href = process.env.REACT_APP_LOGIN_URL
            }
        }
    };

    const handleClear = () => {
        setSelectedGender('');
        setSelectedAgeGroup('');
    }

    console.log("userInfo", userInfo);

    return (
        <>

            {/* <div className="card mb-4 shadow-sm p-3">
                <div className="row d-flex justify-content-between align-items-center">
                    <div className="col-md-8">
                        <h4 className="fw-bold mb-2">Welcome to Inclusional</h4>
                        <p className="mb-0 fw-bold">Empowering organisations with inclusive knowledge and growth!</p>
                        <small className="text-muted">
                            Get a step-by-step guide to effortlessly comply with the law of the land, invite employees to courses, track progress status, and much more!
                        </small>
                    </div>
                    <div className='col-md-4 text-end'>
                        <a href='/'>
                            <img
                                src="/images/Layer_2.svg"
                                alt="logo"
                                className="img-fluid"
                            />
                        </a>
                    </div>
                </div>
            </div> */}

            {!userInfo.gender || !userInfo.age_group && (userInfo?.gender == 'Prefer not to state' && userInfo?.age_group == 'Prefer not to state') ? (
                <div className="card mb-4">
                    <div className="card-body mb-6">
                        <h6 className='fw-bold font-26'>   <img
                            src="/images/info.png"
                            alt="group icon"
                            style={{ width: "25px", height: "25px", marginRight: "8px" }}
                        />Add information <img src='/images/i_icon.svg' onClick={openVideoModal} alt='add icon' style={{ width: "30px", height: "35px", cursor: "pointer", }} /></h6>
                        <hr />
                        <form>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group age">
                                        <label htmlFor="ageSelect" className="fw-bold font-10 mb-4">
                                            What is your age group?
                                        </label>
                                        <CustomSelect
                                            name="selectedAgeGroup"
                                            placeholder="Choose your Age Group"
                                            options={ageGroupOptions}
                                            value={selectedAgeGroup}
                                            onChange={handleAgeGroupChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group gender">
                                        <label htmlFor="genderSelect" className="fw-bold font-10 mb-4">
                                            What is your gender?
                                        </label>
                                        <CustomSelect
                                            name="selectedGender"
                                            placeholder="Select Gender"
                                            options={genderOptions}
                                            value={selectedGender}
                                            onChange={handleGenderChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 text-end">
                                    <div className="form-group gender d-flex justify-content-end align-items-center mt-5">
                                        <button type='button' className="btn btn-md btn-light border px-5 py-2 border-radius-50 me-3" onClick={handleClear}>
                                            Clear
                                        </button>
                                        <button type='button' className="btn btn-md btn-primary px-5 py-2 border-radius-50" onClick={handleSubmit}>
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <Modal
                        isOpen={isModalOpen}
                        onRequestClose={closeVideoModal}
                        contentLabel="Video Modal"
                        className='videoModal bg-white  p-4'
                    > <button type="button" className="close text-white" onClick={closeVideoModal}> <svg width="20" height="20" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                        <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                    </svg></button>
                        <div className='d-flex justify-content-start align-items-center border-bottom text-left pb-2'>
                            <img src='/images/info-icon.svg' className='me-2' alt="Age & Gender Icon" style={{ width: "40px", height: "40px" }} />
                            <h2 className='font-20 fw-bold text-left mb-0'>Why do we collect Age & Gender?</h2>
                        </div>
                        <div className='modal-body pt-4'>
                            <p className='small'>We collect age and gender information solely to provide your organisation with detailed insights into overall training effectiveness and workplace trends. This data is completely confidential, anonymous, and will never be shared—even with your employer. We do not store this information, and it is used only for analysis to enhance workplace inclusivity and performance.</p>
                        </div>
                    </Modal>
                </div>) : null}

        </>
    )
}

export default Details;